import { findCategoryFacet } from '@/features/shop/services/Search/utils'
import { useValidSearchParams } from '@/features/shared/hooks/search'
import { useCurrentActiveOrderId } from '@/features/shop/state/SelectedActiveOrder/hooks'
import { useInfiniteQuerySearch } from '@/features/shop/services/Search/queries'
import { SkeletonProvider } from '@/features/shared/components/SkeletonLoader'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { FeaturedPromotionContent } from '@/features/shop/components/FeaturedPromotionContainer/FeaturedPromotionContent'
import { BackButton } from '@/features/shop/components/ProductDetail/BackButton'
import { LoadingIndicator } from '@shipt/design-system-loading'
import { Row } from '@shipt/design-system-layouts'
import { ErrorPage } from '@/features/shared/components/ErrorPage'
import { ProductNoResultsState } from '@/features/shop/components/ProductNoResultsState'
import { useQueryFeaturedPromotionByCategory } from '@/features/shop/components/FeaturedPromotionContainer/fetchers'

export const FeaturedPromotionPage = () => {
  const currentActiveOrderId = useCurrentActiveOrderId()
  const { promotion_category_id = 0 } = useValidSearchParams()
  const { data: featuredPromotion, isLoading: isFeaturedPromotionLoading } =
    useQueryFeaturedPromotionByCategory(promotion_category_id)
  const infiniteQueryResults = useInfiniteQuerySearch({ shouldTrack: true })
  const { isFetching, isFetchingNextPage, error, isPending, searchResults } = infiniteQueryResults
  const searchInProgress = isFetching && !isFetchingNextPage
  const { total_hits, facets } = searchResults
  const { items } = findCategoryFacet(facets) ?? {}

  const showProgressBar = !currentActiveOrderId && !!featuredPromotion

  let headerTitle: string | undefined
  if (featuredPromotion?.progressHeader) {
    // if featured promotion exists for promoId, show progressHeader
    headerTitle = featuredPromotion.progressHeader
  } else {
    // else, this is a non-offer promo, so use first category
    headerTitle = items?.[0]?.name
  }

  if (isPending || isFeaturedPromotionLoading)
    return (
      <Row align="center" justify="center" paddingTop="xxl">
        <LoadingIndicator size="xl" />
      </Row>
    )
  if (error) return <ErrorPage />
  if (!total_hits) {
    return (
      <Row align="center" justify="center" paddingTop="xxl">
        <ProductNoResultsState message="No products are available at" />
      </Row>
    )
  }

  return (
    <SkeletonProvider isLoading={searchInProgress}>
      <GridLayoutContainer>
        <BackButton showLabel />
        <FeaturedPromotionContent
          headerTitle={headerTitle}
          showProgressBar={showProgressBar}
          featuredPromotion={featuredPromotion ?? undefined}
          infiniteQueryResults={infiniteQueryResults}
          facets={facets}
          total_hits={total_hits}
        />
      </GridLayoutContainer>
    </SkeletonProvider>
  )
}
